<button
  [type]="buttonType()"
  class="btn btn-{{ theme() }}"
  [style.maxWidth]="maxWidth()"
  (click)="onClickButton($event)"
  [disabled]="disabled() || loading()"
>
  @if (loading()) {
    <span class="material-symbols-outlined spin" aria-hidden="true">progress_activity</span>
  }
  <span class="btn-label">{{ label() }}</span>
</button>
